<template>
    <TransitionGroup name="fade" tag="div" class="custom-alert-container">
        <div v-for="alert in alerts"
            :key="alert.id"
            :class="`custom-alert custom-alert--${alert.type}`"
        >
            <div class="custom-alert__icon">
                <img :src="`/images/alert-${alert.type}.svg`" :alt="`alert-${alert.type}`">
            </div>
            <div class="custom-alert__message">
                <div class="custom-alert__title">{{ alert.title }}</div>
                <div class="custom-alert__text">{{ alert.text }}</div>
            </div>
            <button @click="deleteAlert(alert.id)" class="custom-alert__close-btn"></button>
        </div>
    </TransitionGroup>
</template>

<script>
    import { mapMutations, mapState } from 'vuex/dist/vuex.cjs.js';
    export default {
        name: 'Alert',

        computed: {
            ...mapState('alerts', ['alerts'])
        },

        methods: {
            ...mapMutations('alerts', ['deleteAlert'])
        }
    }
</script>

<style lang="scss" scoped>

</style>